import type { PropertyValidationResult } from '../../../types/properties';

export default function validator(properties: Record<string, any>): PropertyValidationResult {
  const errors: Array<{ key: string; message: string }> = [];

  const resource = properties.resource;
  const operation = properties.operation;

  // Validate credential
  if (!properties.credentialId) {
    errors.push({ key: 'credentialId', message: 'Azure Blob Storage credentials are required' });
  }

  // Validate container name for most operations
  if (resource === 'blob' || (resource === 'container' && ['create', 'delete', 'get'].includes(operation))) {
    if (!properties.containerName) {
      errors.push({ key: 'containerName', message: 'Container name is required' });
    }
  }

  // Validate blob name for blob operations
  if (resource === 'blob' && ['copy', 'delete', 'download', 'get', 'upload'].includes(operation)) {
    if (!properties.blobName) {
      errors.push({ key: 'blobName', message: 'Blob name is required' });
    }
  }

  // Validate upload content
  if (resource === 'blob' && operation === 'upload') {
    if (!properties.contentBase64) {
      errors.push({ key: 'contentBase64', message: 'File content (Base64) is required for upload' });
    }
  }

  // Validate limit
  if (operation === 'getMany' && !properties.returnAll) {
    const limit = properties.limit as number;
    if (limit !== undefined && (limit < 1 || limit > 5000)) {
      errors.push({ key: 'limit', message: 'Limit should be between 1 and 5000' });
    }
  }

  return {
    valid: errors.length === 0,
    errors
  };
}
